import { render, staticRenderFns } from "./ProductSellTable.vue?vue&type=template&id=80bff804&scoped=true"
import script from "./ProductSellTable.vue?vue&type=script&lang=js"
export * from "./ProductSellTable.vue?vue&type=script&lang=js"
import style0 from "./ProductSellTable.vue?vue&type=style&index=0&id=80bff804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bff804",
  null
  
)

export default component.exports